import clsx from 'clsx';
import Header from './Header';
import { useDispatch } from 'react-redux';
import ScrollToTop from 'react-scroll-up';
import { useSelector } from 'react-redux';
import { ArrowBack } from '@material-ui/icons';
import PageLoader from '../../components/PageLoader';
import React, { useContext, useEffect } from 'react';
import { releaseLockedProcess } from '../../util/Rest';
import { useHistory, useLocation } from 'react-router';
import ForwardIcon from '@material-ui/icons/ArrowForward';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import VerticalSplitIcon from '@material-ui/icons/VerticalSplit';
import { ThemeContext } from '../../../src/themes/ThemeProvider';
import { SPLIT_SCREEN } from '../../constants/WorkQueueConstants';
import SelectComponent from '../ClientMaintainance/SelectComponent';
import { setShowDashboardWorkQueue } from '../../redux/reducers/role';
import HeaderForwardBackward from '../../components/HeaderForwardBackward';
import { resetFavoriteWindow } from '../../redux/reducers/FavouriteWindows';
import { Tooltip, Button, IconButton, makeStyles } from '@material-ui/core';
import { changeWorkQueueSession, resetData } from '../../redux/reducers/WorkQueueList';
import SelectTabContextProvider from '../../components/SelectTabContext/SelectTabContext';

const LadingPage = ({
  children,
  handleFullScreen,
  tabs,
  setTabs,
  selected,
  setSelected,
  title,
  showTabs,
  tabValue,
  handleTabChange,
  allAntTabs,
}) => {
  const {
    fullScreenForCont,
    setFullScreenForCont,
    setNBTab,
    setToggleWorkqueue,
    setCurrentSelectedTab,
  } = useContext(SelectTabContextProvider);

  const useStyles = makeStyles((theme) => ({
    iconRoot: {
      position: 'relative',
      color: theme.palette.common.white,
      '&:hover, &.active': {
        color: theme.palette.common.white,
      },
    },
    expandIcon: {
      color: '#fff',
      padding: '5px',
      backgroundColor: 'rgb(14 14 14 / 70%)',
      borderRadius: '50px',
      fontSize: '40px',
    },
    // classes for ant tabs
    root: {
      flexGrow: 1,
      width: '100%',
      borderRadius: '5px',
    },
    padding: {
      padding: theme.spacing(3),
    },
    demo1: {
      backgroundColor: '#296bff',
      color: 'white',
      borderRadius: '6px',
    },
  }));
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const { pathname } = location;
  const history = useHistory();
  const accountNumber = location?.state?.accountNumber ? location.state.accountNumber : '';
  const accountData = location?.state?.accountData ? location.state.accountData : [];
  const { showDashboardWorkQueue } = useSelector(({ role }) => role);

  useEffect(() => {
    if (showDashboardWorkQueue === SPLIT_SCREEN.SHOW_SPLIT_SCREEN) {
      setToggleWorkqueue(true);
    } else {
      setToggleWorkqueue(false);
    }
  }, [showDashboardWorkQueue]);
  useEffect(() => {
    if (!showDashboardWorkQueue) {
      sessionStorage.removeItem('workQueueNextAccount');
    }
  }, []);

  const isLoading = JSON.parse(sessionStorage.getItem('isLoading'));
  useEffect(() => {
    if (location.pathname !== '/account-summary' && location.pathname !== '/patient-search') {
      releaseLockedProcess();
    }
  }, [location.pathname]);

  const handleNext = () => {
    const Index = accountData?.length > 0 ? accountData.indexOf(accountNumber) : null;
    history.push({
      pathname: '/account-summary',
      state: {
        accountNumber: Index >= 0 ? accountData[Index + 1] : null,
        accountData: location?.state?.accountData ? location.state.accountData : [],
        batchName: location?.state?.batchName ? location.state.batchName : null,
      },
    });
  };
  const handlePrevious = () => {
    const Index = accountData?.length > 0 ? accountData.indexOf(accountNumber) : null;
    history.push({
      pathname: '/account-summary',
      state: {
        accountNumber: Index >= 0 ? accountData[Index - 1] : null,
        accountData: location?.state?.accountData ? location.state.accountData : [],
        batchName: location?.state?.batchName ? location.state.batchName : null,
      },
    });
  };

  if (document.addEventListener) {
    document.addEventListener('webkitfullscreenchange', exitHandler, false);
    document.addEventListener('mozfullscreenchange', exitHandler, false);
    document.addEventListener('fullscreenchange', exitHandler, false);
    document.addEventListener('MSFullscreenChange', exitHandler, false);
  }

  function exitHandler() {
    if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
      setFullScreenForCont(false);
    }
  }

  window.onbeforeunload = function (e) {
    localStorage.removeItem('workQueueId');
    sessionStorage.removeItem('shouldEffectRun');
  };
  useEffect(() => {
    if (!['/account-summary', '/patient-search'].includes(location.pathname)) {
      sessionStorage.removeItem('shouldEffectRun');
      setCurrentSelectedTab({});
      dispatch(resetFavoriteWindow());
    }
  }, []);
  const getIsNotInMainPage = () => {
    return (
      pathname.toLowerCase().includes('letter-maintenance') ||
      pathname.toLowerCase().includes('global-field') ||
      pathname.toLowerCase().includes('bre') ||
      pathname.toLowerCase().includes('record-format') ||
      pathname.toLowerCase().includes('reports') || // changed path as per URL
      pathname.toLowerCase().includes('client-maintenance') ||
      pathname.toLowerCase().includes('event-tactics') ||
      pathname.toLowerCase().includes('event-triggers') ||
      pathname.toLowerCase().includes('event-client-maintenance') ||
      pathname.toLowerCase().includes('enable-framework') ||
      pathname.toLowerCase().includes('rate-table-page') ||
      pathname.toLowerCase().includes('custom-window') ||
      pathname.toLowerCase().includes('scheduler') ||
      pathname.toLowerCase().includes('parent-client') ||
      pathname.toLowerCase().includes('client-form') ||
      pathname.toLowerCase().includes('nb-maintenance') ||
      pathname.toLowerCase().includes('role-management') ||
      pathname.toLowerCase().includes('user-management') ||
      pathname.toLowerCase().includes('lookup-maintenance') ||
      pathname.toLowerCase().includes('add-parent-form') ||
      pathname.toLowerCase().includes('patient-search') ||
      pathname.toLowerCase().includes('rate-table') ||
      pathname.toLowerCase().includes('client-search') ||
      pathname.toLowerCase().includes('data-manager') ||
      pathname.toLowerCase().includes('work-queue') ||
      pathname.toLowerCase().includes('letter-batches') ||
      pathname.toLowerCase().includes('letter-request') ||
      pathname.toLowerCase().includes('add-account') ||
      pathname.toLowerCase().includes('data-repository') ||
      pathname.toLowerCase().includes('field-list') ||
      pathname.toLowerCase().includes('filter-rules') ||
      pathname.toLowerCase().includes('data-calculation') ||
      pathname.toLowerCase().includes('import-manager') ||
      pathname.toLowerCase().includes('import-template-record') ||
      pathname.toLowerCase().includes('export-manager') ||
      pathname.toLowerCase().includes('export-template-record') ||
      pathname.toLowerCase().includes('staging-repository') ||
      pathname.toLowerCase().includes('new-business') ||
      pathname.toLowerCase().includes('batch-account-list') ||
      pathname.toLowerCase().includes('import-record-group') ||
      pathname.toLowerCase().includes('export-record-group') ||
      pathname.toLowerCase().includes('client-organization') ||
      pathname.toLowerCase().includes('dm-export-execution-history') ||
      pathname.toLowerCase().includes('dm-import-execution-history') ||
      pathname.toLowerCase().includes('scheduler-execution-history') ||
      pathname.toLowerCase().includes('translation-table') ||
      pathname.toLowerCase().includes('/client-tenants') ||
      pathname.toLowerCase().includes('frameworks-edi-export') ||
      pathname.toLowerCase().includes('frameworks-edi-import') ||
      pathname.toLowerCase().includes('/billing-indicator-maintenance')
    );

    // return isNotInMainPage;
  };
  const { sideNavSection, showWidgetSection } = useContext(ThemeContext);
  return (
    <>
      <div
        className={`${
          sideNavSection && !showWidgetSection ? 'landing-page' : 'landing-page landing-page-open'
        }`}
        role="main"
      >
        <Header title="Account Summary" />
        <div className="col" style={{ padding: '0' }}>
          <div
            className={`${
              showTabs ? `row align-items-center global-field-header` : `row align-items-center`
            }`}
          >
            {showDashboardWorkQueue === SPLIT_SCREEN.SHOW_SPLIT_SCREEN &&
            location.pathname === `/account-summary` ? (
                <div className="split-icon" onClick={() => setToggleWorkqueue((ps) => !ps)}>
                  <Tooltip title="Split Screen">
                    <VerticalSplitIcon />
                  </Tooltip>
                </div>
              ) : null}
            {pathname.toLowerCase().includes('/client-maintenance') && (
              <div className="col-sm-6 ">
                <SelectComponent
                  tabs={tabs}
                  setTabs={setTabs}
                  selected={selected}
                  setSelected={setSelected}
                />
              </div>
            )}
            <div
              className={
                getIsNotInMainPage()
                  ? `${
                      showTabs
                        ? 'col-sm-4 col-lg-4 col-md-3 col-xl-3 landing-icons global-field-icons'
                        : location.pathname === `/patient-search`
                          ? 'col-sm-3 col-md-5 col-lg-5 col-xl-5  landing-icons'
                          : 'col-sm-3 col-lg-4 col-xl-12  landing-icons'
                    }`
                  : location.pathname === `/account-summary` && location?.state?.batchName
                    ? `col-sm-12 col-lg-6  landing-icons`
                    : location.pathname === `/account-summary` &&
                    (showDashboardWorkQueue === 'N' ||
                      SPLIT_SCREEN.ARRAY_VALUES.includes(showDashboardWorkQueue)) &&
                    sideNavSection
                      ? `col-sm-12 col-md-12 col-lg-5 landing-icons wq-landing-icons `
                      : `col-sm-12 col-md-12 col-lg-5 landing-icons`
              }
            >
              {/* <div className="d-flex align-items-center  menu-icons"> */}
              <div
                className={
                  fullScreenForCont
                    ? location.pathname === `/account-summary` && location?.state?.batchName
                      ? `nb-button-icon menu-icons`
                      : getIsNotInMainPage()
                        ? 'zoom-in-screen account-zoom-in '
                        : 'account-zoom-in '
                    : pathname.toLowerCase().includes('letter-maintenance') ||
                      getIsNotInMainPage() ||
                      pathname.toLowerCase().includes('client-search') ||
                      getIsNotInMainPage()
                      ? 'profile-icons menu-icons'
                      : `menu-icons `
                }
              >
                <ul>
                  {location.pathname === `/account-summary` && location?.state?.batchName && (
                    <li className="forward-backward">
                      <div className="new-business-text text-center">
                        <p>This is a New Business Account</p>
                      </div>
                      <div className="account-backward-sec">
                        <IconButton
                          onClick={() => handlePrevious()}
                          disabled={accountData?.indexOf(accountNumber) === 0}
                          className={clsx(classes.iconRoot, 'Cmt-appIcon', {})}
                        >
                          <ArrowBack />
                        </IconButton>
                        <Button
                          variant="contained"
                          className="themeing-buttons button"
                          color="primary"
                          onClick={() => {
                            setNBTab(location?.state?.batchName);
                            history.push({
                              pathname: '/new-business-maintenance/nb-maintenance',
                              state: {
                                accountNumber: location?.state?.accountNumber
                                  ? location?.state?.accountNumber
                                  : '',
                                batchName: location?.state?.batchName
                                  ? location?.state?.batchName
                                  : '',
                              },
                            });
                          }}
                        >
                          {`NB-${location?.state?.batchName}`}
                        </Button>

                        <IconButton
                          onClick={() => handleNext()}
                          disabled={accountData?.indexOf(accountNumber) === accountData.length - 1}
                          className={clsx(classes.iconRoot, 'Cmt-appIcon', {})}
                          // disabled={position + 1 === Arr.length - 1}
                        >
                          <ForwardIcon />
                        </IconButton>
                      </div>
                    </li>
                  )}

                  {/* {!fullScreenForCont && (
                    <Tooltip title="Full Screen">
                      <li className="zoom-out">
                        <div
                          onClick={() => {
                            openFullscreen();
                          }}
                        >
                          <ZoomOutMapRoundedIcon />
                        </div>
                      </li>
                    </Tooltip>
                  )}
                  {fullScreenForCont && (
                    <Tooltip title="Exit Full Screen">
                      <li className="zoom-in">
                        <div
                          onClick={() => {
                            closeFullscreen();
                          }}
                        >
                          <CropFreeIcon />
                        </div>
                      </li>
                    </Tooltip>
                  )}
                  <li className="notification-icon">
                    <HeaderNotifications />
                  </li>
                  {pathname.toLowerCase() === '/account-summary' && (
                    <li className="favorite-icon">
                      <HeaderFavourites />
                    </li>
                  )} */}
                  {/* <li className="profile">
                    <Profile showTabs={showTabs} getIsNotInMainPage={getIsNotInMainPage} />
                  </li> */}
                </ul>
              </div>
            </div>
            {showDashboardWorkQueue && location.pathname === `/account-summary` ? (
              <>
                <div className="workqueue-button">
                  <>
                    {SPLIT_SCREEN.DONT_SHOW_SPLIT_SCREEN.includes(showDashboardWorkQueue) ? (
                      <Button
                        className="workqueue-back-button"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          dispatch(setShowDashboardWorkQueue(''));
                          const { workQueueNextAccount } = changeWorkQueueSession();
                          history.push({
                            pathname: '/work-queue-list',
                            state: {
                              accountNumber: '',
                              from: '/account-summary',
                              workQueueRowData: workQueueNextAccount?.workQueueRowData,
                              payload: workQueueNextAccount?.payload,
                            },
                          });
                          dispatch(resetData());
                        }}
                      >
                        <ArrowBack className="mr-2" />
                        Back To Work Queue List
                      </Button>
                    ) : (
                      ''
                    )}
                    {['N', SPLIT_SCREEN.SHOW_SPLIT_SCREEN].includes(showDashboardWorkQueue) ? (
                      <Button
                        className="workqueue-back-button"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          dispatch(setShowDashboardWorkQueue(''));
                          history.push({
                            pathname: '/work-queue',
                            state: {
                              accountNumber: '',
                            },
                          });
                          dispatch(resetData());
                        }}
                      >
                        <ArrowBack className="mr-2" />
                        Back To Work Queue
                      </Button>
                    ) : (
                      ''
                    )}
                  </>
                  <div>
                    <li className="forward-backward">
                      <HeaderForwardBackward />
                    </li>
                  </div>
                </div>
              </>
            ) : null}
          </div>
          {children}
          <ScrollToTop
            style={{
              zIndex: '999',
            }}
            showUnder={160}
          >
            <Tooltip title="Go To Top">
              <ExpandLessIcon className={classes.expandIcon} />
            </Tooltip>
          </ScrollToTop>
        </div>
      </div>
      {isLoading && <PageLoader />}
    </>
  );
};

export default LadingPage;
